import { Box, SxProps, Theme } from '@mui/material';
import React, { ReactElement } from 'react';
import AddIcon from '@mui/icons-material/Add';
import { Color } from 'shared/utils/colors';

interface PlusIconProps {
  disabled?: boolean;
  /** Override the badge circle fill (e.g. brand yellow on the mobile CTA). */
  badgeColor?: string;
  /** Override the plus glyph color (e.g. black on a yellow badge). */
  glyphColor?: string;
}

const badgeSx = {
  height: '24px',
  width: '24px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  backgroundColor: Color.black,
  color: Color.white,
  fontSize: '1rem',
  lineHeight: '22px',
  textAlign: 'center',
  '& > .MuiSvgIcon-root': {
    width: '16px',
    height: '16px',
  },
} satisfies SxProps<Theme>;

function PlusIcon(props: PlusIconProps): ReactElement {
  const { disabled, badgeColor, glyphColor } = props;
  return (
    <Box
      sx={{
        ...badgeSx,
        ...(disabled
          ? { backgroundColor: 'action.disabled' }
          : {
              ...(badgeColor ? { backgroundColor: badgeColor } : {}),
              ...(glyphColor ? { color: glyphColor } : {}),
            }),
      }}
    >
      <AddIcon />
    </Box>
  );
}

export const MemoPlusIcon = React.memo(PlusIcon);
